import { AccountCapabilities } from 'types/capabilities/capabilities'
import { OrchestratedCustomerWallet } from 'types/customers'

export const CustomerModels = {
  EMBEDDED: 'EMBEDDED',
  NESTED: 'NESTED',
} as const

export type CustomerModel = (typeof CustomerModels)[keyof typeof CustomerModels]

export type ConfirmCustomerDetail = {
  label: string
  value: string
}

export type GetCustomerAddressOptions = {
  usePostalCode?: boolean
  useFullAddress?: boolean
  useAddressExcludingCountry?: boolean
}

export type CryptoSendAndReceiveOptions = {
  isCryptoSendOptionEnabled: boolean
  isCryptoReceiveOptionEnabled: boolean
}

export type FiatPayinAndPayoutOptions = {
  isUnifiedPayoutOptionEnabled: boolean
  isMoveOptionEnabled: boolean
  isFiatDepositOptionEnabled: boolean
}

export type WalletActionOptions = CryptoSendAndReceiveOptions &
  FiatPayinAndPayoutOptions & {
    isTransactionExportOptionEnabled: boolean
  }

export type UseCustomerWalletActionsProps = {
  accountCapabilities: AccountCapabilities
  customerWallet: OrchestratedCustomerWallet
  isViewOnlyRole: boolean
  customerModel: CustomerModel
}

export type GetCryptoSendAndReceiveOptionsProps = {
  customerWallet: OrchestratedCustomerWallet
  isEmbeddedCustomer: boolean
  isViewOnlyRole: boolean
  isActive: boolean
  isEpcWalletPayoutsCapabilityEnabled: boolean
  isEpcWalletPayinsCapabilityEnabled: boolean
}

export type GetFiatPayinAndPayoutOptionsProps = {
  isEmbeddedCustomer: boolean
  isViewOnlyRole: boolean
  supportsThirdParty: boolean
  isActive: boolean
  isEpcWalletPayoutsCapabilityEnabled: boolean
  isEpcWalletPayinsCapabilityEnabled: boolean
  supportsInternalTransfers: boolean
  supportsDeposits: boolean
  isEpcWalletInternalTransfersCapabilityEnabled: boolean
}
